<template>
  <v-container fluid grid-list-lg>
    <v-layout column warp mx-5>
      <template>
        <!-- Title Section -->
        <v-card-title>
          <v-row>
            <v-spacer />
            <v-col md="3">
              <v-text-field
                @input="debounceInput"
                :value="filter.search"
                clearable
                prepend-icon="search"
                label="Search"
                single-line
                hide-details
              />
            </v-col>
          </v-row>
        </v-card-title>

        <v-row class="mt-5">
          <!-- Provider Type Table -->
          <v-data-table
            :footer-props="{ 'items-per-page-options': rowsPerPageItems }"
            :options.sync="pagination"
            :server-items-length="totalProviderTypes"
            :headers="headers"
            :items="providerTypes"
            :loading="loading"
            item-key="id"
            class="full-width full-height"
            hide-default-footer
          >
            <v-progress-linear v-slot:progress color="blue" indeterminate />
            <template v-if="providerTypes.length" v-slot:body="{ items }">
              <tbody>
                <tr v-for="item in items" :key="item.id" :style="{ cursor: 'pointer' }">
                  <td class="text-center">{{ item.name_th }}</td>
                  <td class="text-center">{{ item.name_en }}</td>
                  <td class="text-center">{{ item.description_en }}</td>
                  <td class="px-0 py-1">
                    <v-flex align-center justify-center layout text-center>
                      <v-menu open-on-hover auto offset-y>
                        <template v-slot:activator="{ on }">
                          <v-btn v-on="on" color="secondary"> Action </v-btn>
                        </template>
                        <v-list>
                          <v-list-item @click="editProviderType(item)">
                            <v-list-item-title>VIEW</v-list-item-title>
                          </v-list-item>
                          <v-list-item @click="deleteProviderType(item)">
                            <v-list-item-title>DELETE</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </v-flex>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </v-row>
      </template>

      <v-row class="mt-10" align="center">
        <div class="d-flex align-center">
          <span class="mr-3" style="font-size: 0.75rem; margin-left: 12px"> Rows per page: </span>
          <v-select v-model="pagination.itemsPerPage" :items="pageOptions" style="font-size: 12px" />

          <v-pagination
            class="navigation_pagination ml-5"
            v-model="pagination.page"
            :length="totalProviderTypesPages"
            :total-visible="10"
          ></v-pagination>
        </div>

        <v-spacer />

        <v-btn slot="activator" color="accent" @click="toggleModal(item)"> Add New Type </v-btn>
      </v-row>
    </v-layout>
  </v-container>
</template>

<style scoped>
.layout > .v-data-table > .v-data-footer {
  background-color: red;
}
</style>

<script>
/*eslint-disable no-unused-vars*/
import { Vue } from 'vue-property-decorator';
import { debounce } from 'lodash';
import store from '../../../store';
import providerTypes from '../../../services/providerTypes';
import { providerMixin } from '../../../transformers/providerProfile';
import tableMixin from '../../../Mixins/table';

export default Vue.extend({
  store,
  mixins: [providerMixin, tableMixin],
  data: () => ({
    pageOptions: [10, 25, 50, 100, 200],
    sort: 'desc',
    totalProviderTypes: 0,
    totalProviderTypesPages: 0,
    loading: false,
    providerTypes: [],
    pagination: {},
    filter: {
      status: [],
      search: null,
    },
    headers: [
      {
        id: 1,
        text: 'Name (TH)',
        align: 'center',
        value: 'name_th',
        sortable: false,
      },
      {
        id: 2,
        text: 'Name (EN)',
        align: 'center',
        value: 'name_en',
        sortable: false,
      },
      {
        id: 3,
        text: 'Description',
        align: 'center',
        value: 'description_en',
        sortable: false,
      },
      {
        id: 4,
        text: 'Action',
        align: 'center',
        value: 'id',
        sortable: false,
      },
    ],
  }),
  watch: {
    filter: {
      handler() {
        this.getProviderTypeList().then((data) => {
          this.providerTypes = data.items;
          this.totalProviderTypes = data.total;
          this.totalProviderTypesPages = data.totalPages;
        });
      },
      deep: true,
    },
    pagination: {
      handler() {
        this.getProviderTypeList().then((data) => {
          this.providerTypes = data.items;
          this.totalProviderTypes = data.total;
          this.totalProviderTypesPages = data.totalPages;
        });
      },
      deep: true,
    },
  },
  methods: {
    editProviderType(item) {
      window.router.push({
        name: 'providerTypeDetail',
        params: {
          id: item.id,
        },
      });
    },
    deleteProviderType(item) {
      console.log('deleteProviderTyep', item);
    },
    getProviderTypeList() {
      this.loading = true;

      return new Promise((resolve, reject) => {
        const { page, itemsPerPage } = this.pagination;

        let query = {};

        if (itemsPerPage !== -1) {
          query.per_page = itemsPerPage;
          query.page = page;
        } else {
          if (this.pagination.total) {
            query.per_page = this.pagination.total;
            query.page = 1;
          }
        }

        query.order = this.order;
        query.sort = this.pagination.sortDesc[0] ? 'asc' : 'desc';

        if (this.search) query.q = this.search;
        if (this.filter.search) query.q = this.filter.search;

        providerTypes
          .all(query)
          .then((data) => {
            const items = data.data;
            const meta = data.meta;
            const total = meta.pagination.total;
            const totalPages = meta.pagination.last_page;

            this.loading = false;
            resolve({
              items,
              total,
              totalPages,
            });
          })
          .catch((err) => {
            this.loading = false;
            reject(err);
          });
      });
    },
    debounceInput: debounce(function (e) {
      this.filter.search = e;
    }, 500),
  },
  mounted() {
    this.getProviderTypeList().then((data) => {
      this.providerTypes = data.items;
      this.totalProviderTypes = data.total;
      this.totalProviderTypesPages = data.totalPages;
    });
  },
});
</script>
